import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pwa-report" }
const _hoisted_2 = { class: "report-header" }
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "templates" }
const _hoisted_5 = { class: "template-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "list-section" }
const _hoisted_8 = { class: "list-header" }
const _hoisted_9 = { class: "count" }
const _hoisted_10 = { class: "report-list" }
const _hoisted_11 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "meta" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "ym-picker" }
const _hoisted_17 = { class: "year-row" }
const _hoisted_18 = { class: "month-grid" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "confirm-dialog" }
const _hoisted_21 = { class: "dialog-title" }
const _hoisted_22 = { class: "dialog-desc" }
const _hoisted_23 = { class: "dialog-actions" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { key: 1 }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

interface Report {
  id: number;
  name: string;
  type: string;
  createdDate: string;
  downloadUrl?: string;
}

interface ReportTemplate {
  id: number;
  name: string;
  icon: string;
  color: string;
  type: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaReport',
  setup(__props) {

const store = useStore();
const user = computed(() => store.state.user);

const isLoading = ref(false);
const isGenerating = ref(false);
const showYearMonthPicker = ref(false);
const showGenerateDialog = ref(false);
const selectedTemplate = ref<ReportTemplate | null>(null);

const getLastMonth = () => {
  const now = new Date();
  const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return { year: lastMonth.getFullYear(), month: lastMonth.getMonth() + 1 };
};

const yearMonth = ref(getLastMonth());
const selectedYearMonth = computed(() => 
  `${yearMonth.value.year}${String(yearMonth.value.month).padStart(2, '0')}`
);

const reports = ref<Report[]>([]);

const reportTemplates: ReportTemplate[] = [
  { id: 1, name: '급여명세서', icon: 'mdi-file-document', color: '#1e3a8a', type: '급여명세서' },
  { id: 2, name: '인건비', icon: 'mdi-chart-line', color: '#059669', type: '인건비보고서' },
  { id: 3, name: '직원현황', icon: 'mdi-account-group', color: '#7c3aed', type: '직원현황' },
  { id: 4, name: '결산', icon: 'mdi-calculator', color: '#dc2626', type: '결산보고서' }
];

const fetchReports = async () => {
  if (!user.value?.m_sisul_code) return;
  try {
    isLoading.value = true;
    const response = await axios.get(`/api/reports/${user.value.m_sisul_code}/${selectedYearMonth.value}`, { withCredentials: true });

    if (response.data.success) {
      reports.value = response.data.data || [];
    } else {
      reports.value = [
        { id: 1, name: `${yearMonth.value.month}월 급여명세서`, type: '급여명세서', createdDate: new Date().toISOString() },
        { id: 2, name: `${yearMonth.value.month}월 인건비 보고서`, type: '인건비보고서', createdDate: new Date().toISOString() }
      ];
    }
  } catch (error) {
    console.error('보고서 조회 오류:', error);
    reports.value = [
      { id: 1, name: `${yearMonth.value.month}월 급여명세서`, type: '급여명세서', createdDate: new Date().toISOString() }
    ];
  } finally {
    isLoading.value = false;
  }
};

const formatYearMonth = (ym: string) => {
  if (!ym || ym.length !== 6) return '';
  return `${ym.substring(0, 4)}.${parseInt(ym.substring(4, 6))}`;
};

const formatDate = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return `${date.getMonth() + 1}/${date.getDate()}`;
};

const selectMonth = (month: number) => {
  yearMonth.value.month = month;
  showYearMonthPicker.value = false;
  fetchReports();
};

const getTypeClass = (type: string) => {
  const map: Record<string, string> = {
    '급여명세서': 'wage', '인건비보고서': 'cost', '직원현황': 'employee', '결산보고서': 'settlement'
  };
  return map[type] || 'default';
};

const getIcon = (type: string) => {
  const map: Record<string, string> = {
    '급여명세서': 'mdi-file-document', '인건비보고서': 'mdi-chart-line', 
    '직원현황': 'mdi-account-group', '결산보고서': 'mdi-calculator'
  };
  return map[type] || 'mdi-file-document';
};

const generateReport = (template: ReportTemplate) => {
  selectedTemplate.value = template;
  showGenerateDialog.value = true;
};

const confirmGenerate = async () => {
  if (!selectedTemplate.value || !user.value?.m_sisul_code) return;
  try {
    isGenerating.value = true;
    const response = await axios.post('/api/reports/generate', {
      sisulCode: user.value.m_sisul_code,
      yearMonth: selectedYearMonth.value,
      type: selectedTemplate.value.type
    }, { withCredentials: true });

    if (response.data.success) {
      store.commit('showSnackbar', { text: '보고서가 생성되었어요!', color: 'success' });
      fetchReports();
    } else {
      const newReport: Report = {
        id: Date.now(),
        name: `${yearMonth.value.month}월 ${selectedTemplate.value.name}`,
        type: selectedTemplate.value.type,
        createdDate: new Date().toISOString()
      };
      reports.value.unshift(newReport);
      store.commit('showSnackbar', { text: '보고서가 생성되었어요!', color: 'success' });
    }
  } catch (error) {
    const newReport: Report = {
      id: Date.now(),
      name: `${yearMonth.value.month}월 ${selectedTemplate.value!.name}`,
      type: selectedTemplate.value!.type,
      createdDate: new Date().toISOString()
    };
    reports.value.unshift(newReport);
    store.commit('showSnackbar', { text: '보고서가 생성되었어요!', color: 'success' });
  } finally {
    isGenerating.value = false;
    showGenerateDialog.value = false;
  }
};

const downloadReport = (report: Report) => {
  store.commit('showSnackbar', { text: `${report.name} 다운로드`, color: 'info' });
  if (report.downloadUrl) window.open(report.downloadUrl, '_blank');
};

onMounted(() => fetchReports());

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "page-title" }, "보고서", -1)),
        _createElementVNode("button", {
          class: "ym-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showYearMonthPicker.value = true))
        }, [
          _createTextVNode(_toDisplayString(formatYearMonth(selectedYearMonth.value)) + " ", 1),
          _createVNode(_component_v_icon, { size: "16" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-chevron-down", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reportTemplates, (template) => {
          return _createElementVNode("button", {
            key: template.id,
            class: "template-btn",
            onClick: ($event: any) => (generateReport(template))
          }, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: template.color
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(template.icon), 1)
              ]),
              _: 2
            }, 1032, ["color"]),
            _createElementVNode("span", null, _toDisplayString(template.name), 1)
          ], 8, _hoisted_6)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "생성된 보고서", -1)),
        _createElementVNode("span", _hoisted_9, _toDisplayString(reports.value.length) + "건", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "report-item skeleton"
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "skeleton-icon" }, null, -1),
                _createElementVNode("div", { class: "skeleton-text" }, null, -1)
              ]))])
            }), 64))
          : (reports.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_v_icon, {
                  size: "40",
                  color: "#d1d5db"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-file-document-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "보고서가 없습니다", -1))
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(reports.value, (report) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: report.id,
                  class: "report-item"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["icon", getTypeClass(report.type)])
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getIcon(report.type)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(report.name), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(report.type) + " · " + _toDisplayString(formatDate(report.createdDate)), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "download-btn",
                    onClick: ($event: any) => (downloadReport(report))
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-download", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_15)
                ]))
              }), 128))
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showYearMonthPicker.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showYearMonthPicker).value = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (yearMonth.value.year--))
                }, [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", null, _toDisplayString(yearMonth.value.year) + "년", 1),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (yearMonth.value.year++))
                }, [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                  return _createElementVNode("button", {
                    key: m,
                    class: _normalizeClass({ active: yearMonth.value.month === m }),
                    onClick: ($event: any) => (selectMonth(m))
                  }, _toDisplayString(m) + "월", 11, _hoisted_19)
                }), 64))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showGenerateDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showGenerateDialog).value = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass(["dialog-icon", selectedTemplate.value?.type])
              }, [
                _createVNode(_component_v_icon, {
                  size: "24",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(selectedTemplate.value?.icon), 1)
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("div", _hoisted_21, _toDisplayString(selectedTemplate.value?.name), 1),
              _createElementVNode("div", _hoisted_22, _toDisplayString(formatYearMonth(selectedYearMonth.value)) + " 보고서 생성", 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "btn secondary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showGenerateDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn primary",
                  onClick: confirmGenerate,
                  disabled: isGenerating.value
                }, [
                  (isGenerating.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "14",
                        width: "2"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "생성"))
                ], 8, _hoisted_24)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: "보고서를 불러오는 중..."
    }, null, 8, ["is-visible"])
  ]))
}
}

})